@if (addressModel?.Line1 || addressModel?.Address) {
<div class="road1">
  {{ addressModel?.Line1 || addressModel?.Address }}
</div>
} @if (addressModel?.Line2 || addressModel?.Address2) {
<div class="road2">
  {{ addressModel?.Line2 || addressModel?.Address2 }}
</div>
}
<div class="cityState">
  @if (addressModel?.City && addressModel?.State) {
  {{ addressModel?.City }}, {{ addressModel?.State }}
  }
  {{ addressModel?.Zip }}
</div>
@if (addressModel?.Country) {
<div class="country">
  {{ addressModel?.Country }}
</div>
}
